import Vue from 'vue';

Vue.mixin({
    beforeRouteUpdate(to, from, next) {
        this.$popup.remove();
        next();
    },
    beforeRouteLeave(to, from, next) {
        this.$popup.remove();
        next();
    },
});
